// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-show {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 16px;
  background: #f8f9ff;
}

.room-show__inner {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
}

.room-show__stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.room-show__card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.room-show__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
}

.room-show__hero-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.room-show__back {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8f9ff;
  color: #0f172a;
  cursor: pointer;
}

.room-show__back:hover {
  background: #f8fafc;
}

[dir='rtl'] .room-show__back .anticon {
  transform: scaleX(-1);
}

.room-show__identity {
  min-width: 0;
}

.room-show__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.room-show__title-row h1 {
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #0f172a;
}

.room-show__code {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.room-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid #a7f3d0;
  background: #ecfdf5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.room-show__status.is-inactive {
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #64748b;
}

.room-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #10b981;
}

.room-show__status.is-active .room-show__status-dot {
  animation: room-show-pulse 1.6s ease-in-out infinite;
}

.room-show__status.is-inactive .room-show__status-dot {
  background: #94a3b8;
}

@keyframes room-show-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.room-show__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748b;
}

.room-show__meta .anticon {
  color: #94a3b8;
}

.room-show__meta-sep {
  margin-inline: 4px;
  color: #cbd5e1;
}

.room-show__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.room-show__edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.room-show__edit:hover {
  background: #f8fafc;
}

.room-show__stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 0 16px 16px;
}

.room-show__stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8f9ff;
}

.room-show__stat p {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.room-show__stat strong {
  display: block;
  margin-top: 2px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.room-show__stat-copy {
  min-width: 0;
}

.room-show__stat-copy strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.room-show__stat-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  color: #0ea5e9;
}

.room-show__stat-icon.is-emerald {
  color: #059669;
}

.room-show__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
}

.room-show__toolbar h2 {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: #0f172a;
}

.room-show__toolbar p {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748b;
}

.room-show__legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px 16px;
  max-width: min(100%, 520px);
  font-size: 12px;
  color: #64748b;
}

.room-show__legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.room-show__legend i {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border-radius: 3px;
  box-sizing: border-box;
}

.room-show__legend i.is-tone-sky {
  background: #e0f2fe;
  border-inline-start: 2px solid #0284c7;
}

.room-show__legend i.is-tone-emerald {
  background: #d1fae5;
  border-inline-start: 2px solid #059669;
}

.room-show__legend i.is-tone-indigo {
  background: #e0e7ff;
  border-inline-start: 2px solid #4f46e5;
}

.room-show__legend i.is-tone-amber {
  background: #fef3c7;
  border-inline-start: 2px solid #d97706;
}

.room-show__legend i.is-tone-violet {
  background: #ede9fe;
  border-inline-start: 2px solid #7c3aed;
}

.room-show__legend i.is-tone-rose {
  background: #ffe4e6;
  border-inline-start: 2px solid #e11d48;
}

.room-show__legend i.is-tone-teal {
  background: #ccfbf1;
  border-inline-start: 2px solid #0d9488;
}

.room-show__legend i.is-tone-orange {
  background: #ffedd5;
  border-inline-start: 2px solid #ea580c;
}

.room-show__legend i.is-tone-fuchsia {
  background: #fae8ff;
  border-inline-start: 2px solid #c026d3;
}

.room-show__legend i.is-tone-cyan {
  background: #cffafe;
  border-inline-start: 2px solid #0891b2;
}

.room-show__legend i.is-tone-lime {
  background: #ecfccb;
  border-inline-start: 2px solid #65a30d;
}

.room-show__legend i.is-tone-blue {
  background: #dbeafe;
  border-inline-start: 2px solid #2563eb;
}

.room-show__legend i.is-inactive {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
}

.room-show__calendar {
  overflow: hidden;
}

.room-show__empty {
  margin: 0;
  padding: 48px 16px;
  text-align: center;
  font-size: 13px;
  color: #64748b;
}

.room-show__scroll {
  overflow-x: auto;
}

.room-show__grid {
  min-width: 1040px;
}

.room-show__head,
.room-show__columns {
  display: grid;
  grid-template-columns: 72px repeat(7, minmax(120px, 1fr));
}

.room-show__head {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9ff;
  border-bottom: 1px solid #e2e8f0;
}

.room-show__time-label,
.room-show__day-head {
  padding: 10px;
  border-inline-end: 1px solid #e2e8f0;
}

.room-show__day-head:last-child,
.room-show__day:last-child {
  border-inline-end: 0;
}

.room-show__time-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
}

.room-show__day-head {
  text-align: center;
}

.room-show__day-head.is-today {
  background: #f0f9ff;
}

.room-show__day-name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.room-show__day-head.is-today .room-show__day-name,
.room-show__day-head.is-today .room-show__day-note {
  color: #0284c7;
  font-weight: 700;
}

.room-show__today-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #0284c7;
}

.room-show__day-note {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #0ea5e9;
}

.room-show__body {
  position: relative;
}

.room-show__lines {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}

.room-show__line {
  height: 64px;
  border-bottom: 1px solid #e2e8f0;
}

.room-show__columns {
  position: relative;
  height: 100%;
}

.room-show__times {
  background: #f8f9ff;
  border-inline-end: 1px solid #e2e8f0;
}

.room-show__hour {
  height: 64px;
  padding: 6px 8px 0;
  text-align: end;
  font-size: 11px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748b;
}

.room-show__day {
  position: relative;
  border-inline-end: 1px solid #e2e8f0;
}

.room-show__day.is-today {
  background: rgba(240, 249, 255, 0.45);
}

.room-show__shift {
  --shift-bg: #e0f2fe;
  --shift-accent: #0284c7;
  --shift-fg: #0c4a6e;
  --shift-muted: #0369a1;
  --shift-chip-border: #bae6fd;
  --shift-foot-border: rgba(186, 230, 253, 0.7);
  --shift-ring: rgba(14, 165, 233, 0.35);

  position: absolute;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  padding: 8px;
  overflow: hidden;
  border: 0;
  border-radius: 8px;
  text-align: start;
  font-family: inherit;
  cursor: pointer;
}

.room-show__shift.is-tone-sky {
  --shift-bg: #e0f2fe;
  --shift-accent: #0284c7;
  --shift-fg: #0c4a6e;
  --shift-muted: #0369a1;
  --shift-chip-border: #bae6fd;
  --shift-foot-border: rgba(186, 230, 253, 0.7);
  --shift-ring: rgba(14, 165, 233, 0.35);
}

.room-show__shift.is-tone-emerald {
  --shift-bg: #d1fae5;
  --shift-accent: #059669;
  --shift-fg: #064e3b;
  --shift-muted: #047857;
  --shift-chip-border: #a7f3d0;
  --shift-foot-border: rgba(167, 243, 208, 0.75);
  --shift-ring: rgba(16, 185, 129, 0.35);
}

.room-show__shift.is-tone-indigo {
  --shift-bg: #e0e7ff;
  --shift-accent: #4f46e5;
  --shift-fg: #312e81;
  --shift-muted: #4338ca;
  --shift-chip-border: #c7d2fe;
  --shift-foot-border: rgba(199, 210, 254, 0.75);
  --shift-ring: rgba(99, 102, 241, 0.35);
}

.room-show__shift.is-tone-amber {
  --shift-bg: #fef3c7;
  --shift-accent: #d97706;
  --shift-fg: #78350f;
  --shift-muted: #b45309;
  --shift-chip-border: #fde68a;
  --shift-foot-border: rgba(253, 230, 138, 0.8);
  --shift-ring: rgba(245, 158, 11, 0.35);
}

.room-show__shift.is-tone-violet {
  --shift-bg: #ede9fe;
  --shift-accent: #7c3aed;
  --shift-fg: #4c1d95;
  --shift-muted: #6d28d9;
  --shift-chip-border: #ddd6fe;
  --shift-foot-border: rgba(221, 214, 254, 0.8);
  --shift-ring: rgba(139, 92, 246, 0.35);
}

.room-show__shift.is-tone-rose {
  --shift-bg: #ffe4e6;
  --shift-accent: #e11d48;
  --shift-fg: #881337;
  --shift-muted: #be123c;
  --shift-chip-border: #fecdd3;
  --shift-foot-border: rgba(254, 205, 211, 0.8);
  --shift-ring: rgba(244, 63, 94, 0.35);
}

.room-show__shift.is-tone-teal {
  --shift-bg: #ccfbf1;
  --shift-accent: #0d9488;
  --shift-fg: #134e4a;
  --shift-muted: #0f766e;
  --shift-chip-border: #99f6e4;
  --shift-foot-border: rgba(153, 246, 228, 0.8);
  --shift-ring: rgba(20, 184, 166, 0.35);
}

.room-show__shift.is-tone-orange {
  --shift-bg: #ffedd5;
  --shift-accent: #ea580c;
  --shift-fg: #7c2d12;
  --shift-muted: #c2410c;
  --shift-chip-border: #fed7aa;
  --shift-foot-border: rgba(254, 215, 170, 0.85);
  --shift-ring: rgba(249, 115, 22, 0.35);
}

.room-show__shift.is-tone-fuchsia {
  --shift-bg: #fae8ff;
  --shift-accent: #c026d3;
  --shift-fg: #701a75;
  --shift-muted: #a21caf;
  --shift-chip-border: #f5d0fe;
  --shift-foot-border: rgba(245, 208, 254, 0.85);
  --shift-ring: rgba(217, 70, 239, 0.35);
}

.room-show__shift.is-tone-cyan {
  --shift-bg: #cffafe;
  --shift-accent: #0891b2;
  --shift-fg: #164e63;
  --shift-muted: #0e7490;
  --shift-chip-border: #a5f3fc;
  --shift-foot-border: rgba(165, 243, 252, 0.85);
  --shift-ring: rgba(6, 182, 212, 0.35);
}

.room-show__shift.is-tone-lime {
  --shift-bg: #ecfccb;
  --shift-accent: #65a30d;
  --shift-fg: #365314;
  --shift-muted: #4d7c0f;
  --shift-chip-border: #d9f99d;
  --shift-foot-border: rgba(217, 249, 157, 0.85);
  --shift-ring: rgba(132, 204, 22, 0.35);
}

.room-show__shift.is-tone-blue {
  --shift-bg: #dbeafe;
  --shift-accent: #2563eb;
  --shift-fg: #1e3a8a;
  --shift-muted: #1d4ed8;
  --shift-chip-border: #bfdbfe;
  --shift-foot-border: rgba(191, 219, 254, 0.85);
  --shift-ring: rgba(59, 130, 246, 0.35);
}

.room-show__shift.is-static,
.room-show__shift:disabled {
  cursor: default;
  opacity: 1;
}

.room-show__shift.is-active {
  background: var(--shift-bg);
  border-inline-start: 4px solid var(--shift-accent);
  color: var(--shift-fg);
}

.room-show__shift.is-active:hover {
  box-shadow: 0 0 0 2px var(--shift-ring);
}

.room-show__shift.is-inactive {
  background: #f1f5f9;
  border-inline-start: 4px solid #64748b;
  color: #1e293b;
}

.room-show__shift-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
}

.room-show__shift-chip {
  padding: 1px 6px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--shift-chip-border);
  color: var(--shift-accent);
  font-size: 10px;
  font-weight: 600;
}

.room-show__shift.is-inactive .room-show__shift-chip {
  border-color: #e2e8f0;
  color: #334155;
}

.room-show__shift-time {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--shift-muted);
}

.room-show__shift.is-inactive .room-show__shift-time {
  color: #475569;
}

.room-show__shift strong {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.room-show__shift em {
  display: block;
  margin-top: 1px;
  font-style: normal;
  font-size: 11px;
  line-height: 14px;
  color: var(--shift-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.room-show__shift.is-inactive em {
  color: #64748b;
}

.room-show__shift-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--shift-foot-border);
  font-size: 11px;
  font-weight: 500;
  color: var(--shift-muted);
}

.room-show__shift.is-inactive .room-show__shift-foot {
  border-top-color: #e2e8f0;
  color: #475569;
}

.room-show__shift-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--shift-accent);
  flex-shrink: 0;
}

.room-show__shift-flag {
  padding: 1px 6px;
  border-radius: 4px;
  background: #e2e8f0;
  color: #334155;
  font-size: 9px;
  font-weight: 600;
}

.room-show__shift.is-compact strong {
  margin-top: 4px;
}

@media print {
  .room-show__back,
  .room-show__actions {
    display: none !important;
  }

  .room-show {
    padding: 0;
    background: #ffffff;
  }

  .room-show__card {
    box-shadow: none;
  }

  .room-show__calendar,
  .room-show__scroll {
    overflow: visible;
  }

  .room-show__grid {
    min-width: 0;
  }

  .room-show__head,
  .room-show__columns {
    grid-template-columns: 56px repeat(7, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .room-show__stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowClinicRoom/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,oCAAoC;AACtC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;;EAEtC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;;EAEE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".room-show {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 16px;\n  background: #f8f9ff;\n}\n\n.room-show__inner {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n}\n\n.room-show__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n.room-show__card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.room-show__hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n}\n\n.room-show__hero-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.room-show__back {\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8f9ff;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.room-show__back:hover {\n  background: #f8fafc;\n}\n\n[dir='rtl'] .room-show__back .anticon {\n  transform: scaleX(-1);\n}\n\n.room-show__identity {\n  min-width: 0;\n}\n\n.room-show__title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.room-show__title-row h1 {\n  margin: 0;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.room-show__code {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.room-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid #a7f3d0;\n  background: #ecfdf5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.room-show__status.is-inactive {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.room-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #10b981;\n}\n\n.room-show__status.is-active .room-show__status-dot {\n  animation: room-show-pulse 1.6s ease-in-out infinite;\n}\n\n.room-show__status.is-inactive .room-show__status-dot {\n  background: #94a3b8;\n}\n\n@keyframes room-show-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n.room-show__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748b;\n}\n\n.room-show__meta .anticon {\n  color: #94a3b8;\n}\n\n.room-show__meta-sep {\n  margin-inline: 4px;\n  color: #cbd5e1;\n}\n\n.room-show__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.room-show__edit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.room-show__edit:hover {\n  background: #f8fafc;\n}\n\n.room-show__stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  padding: 0 16px 16px;\n}\n\n.room-show__stat {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-width: 0;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8f9ff;\n}\n\n.room-show__stat p {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.room-show__stat strong {\n  display: block;\n  margin-top: 2px;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.room-show__stat-copy {\n  min-width: 0;\n}\n\n.room-show__stat-copy strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n.room-show__stat-icon {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #0ea5e9;\n}\n\n.room-show__stat-icon.is-emerald {\n  color: #059669;\n}\n\n.room-show__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n}\n\n.room-show__toolbar h2 {\n  margin: 0;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.room-show__toolbar p {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748b;\n}\n\n.room-show__legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px 16px;\n  max-width: min(100%, 520px);\n  font-size: 12px;\n  color: #64748b;\n}\n\n.room-show__legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.room-show__legend i {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  box-sizing: border-box;\n}\n\n.room-show__legend i.is-tone-sky {\n  background: #e0f2fe;\n  border-inline-start: 2px solid #0284c7;\n}\n\n.room-show__legend i.is-tone-emerald {\n  background: #d1fae5;\n  border-inline-start: 2px solid #059669;\n}\n\n.room-show__legend i.is-tone-indigo {\n  background: #e0e7ff;\n  border-inline-start: 2px solid #4f46e5;\n}\n\n.room-show__legend i.is-tone-amber {\n  background: #fef3c7;\n  border-inline-start: 2px solid #d97706;\n}\n\n.room-show__legend i.is-tone-violet {\n  background: #ede9fe;\n  border-inline-start: 2px solid #7c3aed;\n}\n\n.room-show__legend i.is-tone-rose {\n  background: #ffe4e6;\n  border-inline-start: 2px solid #e11d48;\n}\n\n.room-show__legend i.is-tone-teal {\n  background: #ccfbf1;\n  border-inline-start: 2px solid #0d9488;\n}\n\n.room-show__legend i.is-tone-orange {\n  background: #ffedd5;\n  border-inline-start: 2px solid #ea580c;\n}\n\n.room-show__legend i.is-tone-fuchsia {\n  background: #fae8ff;\n  border-inline-start: 2px solid #c026d3;\n}\n\n.room-show__legend i.is-tone-cyan {\n  background: #cffafe;\n  border-inline-start: 2px solid #0891b2;\n}\n\n.room-show__legend i.is-tone-lime {\n  background: #ecfccb;\n  border-inline-start: 2px solid #65a30d;\n}\n\n.room-show__legend i.is-tone-blue {\n  background: #dbeafe;\n  border-inline-start: 2px solid #2563eb;\n}\n\n.room-show__legend i.is-inactive {\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n}\n\n.room-show__calendar {\n  overflow: hidden;\n}\n\n.room-show__empty {\n  margin: 0;\n  padding: 48px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.room-show__scroll {\n  overflow-x: auto;\n}\n\n.room-show__grid {\n  min-width: 1040px;\n}\n\n.room-show__head,\n.room-show__columns {\n  display: grid;\n  grid-template-columns: 72px repeat(7, minmax(120px, 1fr));\n}\n\n.room-show__head {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9ff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.room-show__time-label,\n.room-show__day-head {\n  padding: 10px;\n  border-inline-end: 1px solid #e2e8f0;\n}\n\n.room-show__day-head:last-child,\n.room-show__day:last-child {\n  border-inline-end: 0;\n}\n\n.room-show__time-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.room-show__day-head {\n  text-align: center;\n}\n\n.room-show__day-head.is-today {\n  background: #f0f9ff;\n}\n\n.room-show__day-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.room-show__day-head.is-today .room-show__day-name,\n.room-show__day-head.is-today .room-show__day-note {\n  color: #0284c7;\n  font-weight: 700;\n}\n\n.room-show__today-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #0284c7;\n}\n\n.room-show__day-note {\n  display: block;\n  margin-top: 2px;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  color: #0ea5e9;\n}\n\n.room-show__body {\n  position: relative;\n}\n\n.room-show__lines {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  pointer-events: none;\n}\n\n.room-show__line {\n  height: 64px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.room-show__columns {\n  position: relative;\n  height: 100%;\n}\n\n.room-show__times {\n  background: #f8f9ff;\n  border-inline-end: 1px solid #e2e8f0;\n}\n\n.room-show__hour {\n  height: 64px;\n  padding: 6px 8px 0;\n  text-align: end;\n  font-size: 11px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748b;\n}\n\n.room-show__day {\n  position: relative;\n  border-inline-end: 1px solid #e2e8f0;\n}\n\n.room-show__day.is-today {\n  background: rgba(240, 249, 255, 0.45);\n}\n\n.room-show__shift {\n  --shift-bg: #e0f2fe;\n  --shift-accent: #0284c7;\n  --shift-fg: #0c4a6e;\n  --shift-muted: #0369a1;\n  --shift-chip-border: #bae6fd;\n  --shift-foot-border: rgba(186, 230, 253, 0.7);\n  --shift-ring: rgba(14, 165, 233, 0.35);\n\n  position: absolute;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 0;\n  padding: 8px;\n  overflow: hidden;\n  border: 0;\n  border-radius: 8px;\n  text-align: start;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.room-show__shift.is-tone-sky {\n  --shift-bg: #e0f2fe;\n  --shift-accent: #0284c7;\n  --shift-fg: #0c4a6e;\n  --shift-muted: #0369a1;\n  --shift-chip-border: #bae6fd;\n  --shift-foot-border: rgba(186, 230, 253, 0.7);\n  --shift-ring: rgba(14, 165, 233, 0.35);\n}\n\n.room-show__shift.is-tone-emerald {\n  --shift-bg: #d1fae5;\n  --shift-accent: #059669;\n  --shift-fg: #064e3b;\n  --shift-muted: #047857;\n  --shift-chip-border: #a7f3d0;\n  --shift-foot-border: rgba(167, 243, 208, 0.75);\n  --shift-ring: rgba(16, 185, 129, 0.35);\n}\n\n.room-show__shift.is-tone-indigo {\n  --shift-bg: #e0e7ff;\n  --shift-accent: #4f46e5;\n  --shift-fg: #312e81;\n  --shift-muted: #4338ca;\n  --shift-chip-border: #c7d2fe;\n  --shift-foot-border: rgba(199, 210, 254, 0.75);\n  --shift-ring: rgba(99, 102, 241, 0.35);\n}\n\n.room-show__shift.is-tone-amber {\n  --shift-bg: #fef3c7;\n  --shift-accent: #d97706;\n  --shift-fg: #78350f;\n  --shift-muted: #b45309;\n  --shift-chip-border: #fde68a;\n  --shift-foot-border: rgba(253, 230, 138, 0.8);\n  --shift-ring: rgba(245, 158, 11, 0.35);\n}\n\n.room-show__shift.is-tone-violet {\n  --shift-bg: #ede9fe;\n  --shift-accent: #7c3aed;\n  --shift-fg: #4c1d95;\n  --shift-muted: #6d28d9;\n  --shift-chip-border: #ddd6fe;\n  --shift-foot-border: rgba(221, 214, 254, 0.8);\n  --shift-ring: rgba(139, 92, 246, 0.35);\n}\n\n.room-show__shift.is-tone-rose {\n  --shift-bg: #ffe4e6;\n  --shift-accent: #e11d48;\n  --shift-fg: #881337;\n  --shift-muted: #be123c;\n  --shift-chip-border: #fecdd3;\n  --shift-foot-border: rgba(254, 205, 211, 0.8);\n  --shift-ring: rgba(244, 63, 94, 0.35);\n}\n\n.room-show__shift.is-tone-teal {\n  --shift-bg: #ccfbf1;\n  --shift-accent: #0d9488;\n  --shift-fg: #134e4a;\n  --shift-muted: #0f766e;\n  --shift-chip-border: #99f6e4;\n  --shift-foot-border: rgba(153, 246, 228, 0.8);\n  --shift-ring: rgba(20, 184, 166, 0.35);\n}\n\n.room-show__shift.is-tone-orange {\n  --shift-bg: #ffedd5;\n  --shift-accent: #ea580c;\n  --shift-fg: #7c2d12;\n  --shift-muted: #c2410c;\n  --shift-chip-border: #fed7aa;\n  --shift-foot-border: rgba(254, 215, 170, 0.85);\n  --shift-ring: rgba(249, 115, 22, 0.35);\n}\n\n.room-show__shift.is-tone-fuchsia {\n  --shift-bg: #fae8ff;\n  --shift-accent: #c026d3;\n  --shift-fg: #701a75;\n  --shift-muted: #a21caf;\n  --shift-chip-border: #f5d0fe;\n  --shift-foot-border: rgba(245, 208, 254, 0.85);\n  --shift-ring: rgba(217, 70, 239, 0.35);\n}\n\n.room-show__shift.is-tone-cyan {\n  --shift-bg: #cffafe;\n  --shift-accent: #0891b2;\n  --shift-fg: #164e63;\n  --shift-muted: #0e7490;\n  --shift-chip-border: #a5f3fc;\n  --shift-foot-border: rgba(165, 243, 252, 0.85);\n  --shift-ring: rgba(6, 182, 212, 0.35);\n}\n\n.room-show__shift.is-tone-lime {\n  --shift-bg: #ecfccb;\n  --shift-accent: #65a30d;\n  --shift-fg: #365314;\n  --shift-muted: #4d7c0f;\n  --shift-chip-border: #d9f99d;\n  --shift-foot-border: rgba(217, 249, 157, 0.85);\n  --shift-ring: rgba(132, 204, 22, 0.35);\n}\n\n.room-show__shift.is-tone-blue {\n  --shift-bg: #dbeafe;\n  --shift-accent: #2563eb;\n  --shift-fg: #1e3a8a;\n  --shift-muted: #1d4ed8;\n  --shift-chip-border: #bfdbfe;\n  --shift-foot-border: rgba(191, 219, 254, 0.85);\n  --shift-ring: rgba(59, 130, 246, 0.35);\n}\n\n.room-show__shift.is-static,\n.room-show__shift:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.room-show__shift.is-active {\n  background: var(--shift-bg);\n  border-inline-start: 4px solid var(--shift-accent);\n  color: var(--shift-fg);\n}\n\n.room-show__shift.is-active:hover {\n  box-shadow: 0 0 0 2px var(--shift-ring);\n}\n\n.room-show__shift.is-inactive {\n  background: #f1f5f9;\n  border-inline-start: 4px solid #64748b;\n  color: #1e293b;\n}\n\n.room-show__shift-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.room-show__shift-chip {\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--shift-chip-border);\n  color: var(--shift-accent);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.room-show__shift.is-inactive .room-show__shift-chip {\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\n.room-show__shift-time {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--shift-muted);\n}\n\n.room-show__shift.is-inactive .room-show__shift-time {\n  color: #475569;\n}\n\n.room-show__shift strong {\n  display: block;\n  margin-top: 2px;\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.room-show__shift em {\n  display: block;\n  margin-top: 1px;\n  font-style: normal;\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--shift-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.room-show__shift.is-inactive em {\n  color: #64748b;\n}\n\n.room-show__shift-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid var(--shift-foot-border);\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--shift-muted);\n}\n\n.room-show__shift.is-inactive .room-show__shift-foot {\n  border-top-color: #e2e8f0;\n  color: #475569;\n}\n\n.room-show__shift-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--shift-accent);\n  flex-shrink: 0;\n}\n\n.room-show__shift-flag {\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: #e2e8f0;\n  color: #334155;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.room-show__shift.is-compact strong {\n  margin-top: 4px;\n}\n\n@media print {\n  .room-show__back,\n  .room-show__actions {\n    display: none !important;\n  }\n\n  .room-show {\n    padding: 0;\n    background: #ffffff;\n  }\n\n  .room-show__card {\n    box-shadow: none;\n  }\n\n  .room-show__calendar,\n  .room-show__scroll {\n    overflow: visible;\n  }\n\n  .room-show__grid {\n    min-width: 0;\n  }\n\n  .room-show__head,\n  .room-show__columns {\n    grid-template-columns: 56px repeat(7, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 900px) {\n  .room-show__stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
